import { useTranslation } from '@crehana/i18n';

import { TKeys } from '../types';

const useCLTranslation = () => useTranslation<TKeys>();

export default useCLTranslation;
